import React, { useState } from "react";
import API from "../Api";

export default function MfaLoginStep({ challengeToken, onSuccess, onCancel }) {
  const [useRecovery, setUseRecovery] = useState(false);
  const [code, setCode] = useState("");
  const [recoveryCode, setRecoveryCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [expired, setExpired] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const path = useRecovery ? "/api/security/mfa/recovery/verify" : "/api/security/mfa/verify";
      const body = useRecovery
        ? { mfaChallengeToken: challengeToken, recoveryCode: recoveryCode.trim() }
        : { mfaChallengeToken: challengeToken, code: code.trim() };
      const res = await API.post(path, body);
      onSuccess(res.data);
    } catch (err) {
      const data = err.response?.data || {};
      const message = data.message || data.error || "The verification code is invalid or expired.";
      setError(message);
      if (data.error === "TOO_MANY_ATTEMPTS" || data.error === "MFA_CHALLENGE_EXPIRED") {
        setExpired(true);
      }
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <h2>{useRecovery ? "Enter recovery code" : "Verify your identity"}</h2>
      <p className="subtitle">
        {useRecovery
          ? "Enter one of the single-use recovery codes you saved when MFA was enabled."
          : "Enter the 6-digit code from your authenticator app."}
      </p>
      {error && <div className="error-message">{error}</div>}
      {useRecovery ? (
        <div className="form-group">
          <label htmlFor="mfa-recovery">Recovery code</label>
          <input
            id="mfa-recovery"
            value={recoveryCode}
            onChange={(e) => setRecoveryCode(e.target.value)}
            placeholder="XXXX-XXXX"
            autoComplete="one-time-code"
            disabled={loading || expired}
            required
          />
        </div>
      ) : (
        <div className="form-group">
          <label htmlFor="mfa-code">Authenticator code</label>
          <input
            id="mfa-code"
            inputMode="numeric"
            autoComplete="one-time-code"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            placeholder="123456"
            disabled={loading || expired}
            required
          />
        </div>
      )}
      <button type="submit" className="login-button" disabled={loading || expired}>
        {loading ? "Verifying..." : "Verify"}
      </button>
      <p style={{ marginTop: 16 }}>
        <button
          type="button"
          className="login-button"
          style={{ background: "transparent", color: "#4f46e5", boxShadow: "none" }}
          onClick={() => {
            setUseRecovery((value) => !value);
            setError("");
          }}
          disabled={expired}
        >
          {useRecovery ? "Use an authenticator code instead" : "Use a recovery code instead"}
        </button>
      </p>
      <button type="button" className="login-button" style={{ background: "#6b7280" }} onClick={onCancel}>
        Back to sign in
      </button>
    </form>
  );
}
